import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSubdomain } from '../hooks/useSubdomain';
import InstructorPublicProfile from '../pages/instructor/InstructorPublicProfile';
import SalePageLanding from '../pages/salepage/SalePageLanding';

export default function SubdomainHandler() {
  const { isSubdomain, username, isSalePageSubdomain } = useSubdomain();
  const location = useLocation();
  const navigate = useNavigate();

  // If on subdomain but trying to access other paths, redirect appropriately
  useEffect(() => {
    // For Salepage subdomain, block /subscription/* routes EXCEPT specific allowed routes
    if (isSalePageSubdomain && location.pathname.startsWith('/subscription/')) {
      // Allow registration and checkout routes
      if (location.pathname === '/subscription/register-info' || 
          location.pathname === '/subscription/register-success') {
        console.log('[SubdomainHandler] Allowing registration route:', location.pathname);
        return;
      }
      
      // Allow /subscription/checkout-new when source=salepage or tier=free (for Salepage payment/free trial)
      const searchParams = new URLSearchParams(location.search);
      const source = searchParams.get('source');
      const tier = searchParams.get('tier');
      if (location.pathname === '/subscription/checkout-new' && (source === 'salepage' || tier === 'free')) {
        console.log('[SubdomainHandler] Allowing /subscription/checkout-new for Salepage payment/free trial');
        return;
      }
      
      console.log('[SubdomainHandler] Blocking subscription route on salepage subdomain, redirecting to /salepage/renew');
      navigate('/salepage/renew', { replace: true });
      return;
    }

    if (isSubdomain && username && !isSalePageSubdomain && location.pathname !== '/') {
      // Allow course pages, sale page, and auth-related pages to work
      if (!location.pathname.startsWith('/courses/') && 
          !location.pathname.startsWith('/checkout/') &&
          !location.pathname.startsWith('/login') &&
          !location.pathname.startsWith('/register') &&
          !location.pathname.startsWith('/complete-profile') &&
          !location.pathname.startsWith('/progress') &&
          !location.pathname.startsWith('/auth/') &&
          !location.pathname.startsWith('/sale')) {
        console.log('[SubdomainHandler] Redirecting to root from:', location.pathname);
        navigate('/', { replace: true });
      }
    }
  }, [isSubdomain, username, isSalePageSubdomain, location.pathname, navigate]);

  // If on salepage subdomain at root path, render SalePageLanding
  if (isSalePageSubdomain && location.pathname === '/') {
    console.log('[SubdomainHandler] Rendering SalePageLanding for salepage subdomain');
    return <SalePageLanding />;
  }

  // If on instructor subdomain at root path, render InstructorPublicProfile
  if (isSubdomain && username && !isSalePageSubdomain && location.pathname === '/') {
    console.log('[SubdomainHandler] Rendering InstructorPublicProfile for subdomain:', username);
    return <InstructorPublicProfile username={username} isSubdomainView={true} />;
  }

  return null;
}
